module.exports = __webpack_public_path__ + "img/katsia.m__600x600.e8054ec1.jpg";